import { Vue, Component, Prop } from 'vue-property-decorator'
import { VBtn, VIcon, VSheet, VSpacer, VToolbarTitle } from 'vuetify/lib'

@Component({})
export class SubHeader extends Vue {
	@Prop({ type: String, required: false }) public title!: string
	@Prop({ type: Boolean, required: false, default: false }) public back!: boolean
	public render() {
		return (
			<VSheet width="100%" height="65" class="d-flex align-center">
				{this.back && (
					<VBtn class="ml-3" icon onClick={() => history.back()} large>
						<VIcon>mdi-arrow-left</VIcon>
					</VBtn>
				)}
				{this.title && <VToolbarTitle>{this.title}</VToolbarTitle>}

				{this.$scopedSlots.default ? (
					<div class="mx-4" style="width: 100%">
						{this.$scopedSlots.default(this.$props)}
					</div>
				) : (
					''
				)}
			</VSheet>
		)
	}
}

export default SubHeader
